export const locale = {
    lang: 'en',
    data: {
        'TOOLBAR_RIGHT': {
            'PROFILE': 'Profile',
            'MAIL': 'Mail',
            'LOGOUT': 'Logout'
        }
    }
};



// WEBPACK FOOTER //
// ./src/@fuse/components/search-bar/i18n/en.ts